/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description SmartTag level constants
 */
export class Constants {

	private static _instance: Constants = new Constants();

	constructor() {
		if ( Constants._instance ) {
			throw new Error( this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()' );
		}
		Constants._instance = this;
	}

	/**
	 * @description Default SmartTag ready page callback if no callback is passed via js?onReady
	 * @returns {string}
	 */
	get FUNCTION_SMART_TAG_ON_READY() {
		return 'onSmartTagReady';
	}

	get name(): string {
		return 'Constants';
	}

	public static getInstance(): Constants {
		return Constants._instance;
	}

}